module.exports = __webpack_public_path__ + "img/DK24255670.5f5a004c.png";